
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';

import React from 'react';
import { burdenRateColumnsList } from '../../constants/MockData';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration, getCurrentPayCycleStartDate } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import moment from 'moment';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import store from '../../store/appStore';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import _ from 'lodash';

export default class CreateReimbursement extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      confirmMessage: null,
      showWarningMessage: false,
      isSplit: false,
      designationMasterData: [],
      burdenMasterData: [],
      isInAddMode: false,
      configuration: [],
      selectedEditRowId: undefined,
      isEditEnable: true,
      validationMessage: [],
      isDelete: false,
      isStartDateSame: false,
      updateData: {
        parentRecordId: 0,
        splitDesignation: false,
        burdenRateId: 0,
        burdenRate: '',
        burdenRatePercent: 0,
        startDate: moment().format('YYYY/MM/DD'),
        endDate: undefined,
        designationId: null,
        designation: undefined,
        flag: false,
        createdBy: '',
        createdDate: moment().format('YYYY/MM/DD'),
        statusId: 0,
        modifiedBy: '',
        modifiedDate: moment().format('YYYY/MM/DD')
      },
      burdenRateColumns: _.cloneDeep(burdenRateColumnsList)
    };
  }

  componentDidMount () {
    this.getRequiredData();
  }

  isDateInSamePayCycle (stdate, date) {
    let isValid = false;
    const currentMonthStartDate = moment(date).startOf('month').format('YYYY/MM/DD');
    const currentMonthMidDate = moment(currentMonthStartDate, 'YYYY/MM/DD').add(14, 'days');
    const currentMonthLastDate = moment(date).endOf('month').format('YYYY/MM/DD');

    if (((date >= currentMonthStartDate && date <= currentMonthMidDate.format('YYYY/MM/DD')) &&
      (stdate >= currentMonthStartDate && stdate <= currentMonthMidDate.format('YYYY/MM/DD'))) || (
      (date >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') && date <= currentMonthLastDate) &&
        (stdate >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') && stdate <= currentMonthLastDate))) { isValid = true; } else { isValid = false; }
    return isValid;
  }

  /**
   * validate burdan rate percent
   * @param {*} val
   * @returns
   */
  isBurdenRateValid (val) {
    let isValid = false;
    const numericInput = new RegExp('^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,2}))))\\s*$');// '/^[0-9\b]+$/');
    isValid = !isNaN(val); // numericInput.test(val);
    if (val < 0 || val > 100 || isValid === false) {
      isValid = true;
      return isValid;
    }
  }

  /**
   * delete record
   */
  deleteRecord (cellInfo) {
    this.setState({
      isDelete: true,
      showWarningMessage: true,
      confirmMessage: 'Do you want to delete this record ?',
      updateData: cellInfo
    });
  };

  /**
   * handle on delete
   * @param {*} e
   */
  onDeleteHandel (e) {
    const newParam = this.state.updateData;
    if (e) {
      // newParam.startDate = null;// '0001-01-01'
      newParam.IsDelete = true;
      this.setState({
        updateData: newParam,
        isDelete: false,
        showWarningMessage: false
      });
      this.saveRecord(newParam);
    } else {
      this.setState({ showWarningMessage: false, confirmationMessage: '' });
    }
  }

  /**
   * return master data from
   */
  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Users.GetBurdenMasterData,
        key: 'burdenMasterData'
      }
    ])
      .then(({ burdenMasterData, designationMasterData }) => {
        this._asyncRequest = null;
        if (designationMasterData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          burdenMasterData: burdenMasterData.data || [],
          designationMasterData: designationMasterData.data || [],
          configuration: burdenMasterData.config || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  /**
  * check if designation is present burden master data
  * @param {*} ele
  * @returns
  */
  isDesignationPresent (ele) {
    const existingDepartmentId = ele.designationId.split('|');
    const newDepartmentId = this.state.updateData.designationId.split('|');

    const matchedDepartment = existingDepartmentId.filter((m) =>
      newDepartmentId.some((n) => m === n)
    );
    return matchedDepartment;
  }

  isDeptExistInBurdenGroup () {
    let newParam = [];
    let isValid = false;
    let isStartDateSame = false;
    let isNewParamValid = false;
    newParam = this.state.updateData;
    let filterBurdenData = '';
    let breakCondition = false;

    this.state.burdenMasterData.forEach((ele) => {
      if (ele.burdenRateId !== this.state.updateData.burdenRateId && ele.endDate !== null &&
        !breakCondition && ele.endDate !== '0001-01-01T00:00:00' &&
        this.state.updateData.startDate >= moment(ele.startDate).format('YYYY/MM/DD') && this.state.updateData.startDate <= moment(ele.endDate).format('YYYY/MM/DD')) {
        const matchedDepartment = this.isDesignationPresent(ele);
        if (matchedDepartment.length > 0) {
          breakCondition = true;
          newParam = null;
          isValid = true;
        }
      }
    }
    );

    if (!isValid) {
      this.state.burdenMasterData.forEach((ele) => {
        if (ele.burdenRateId !== this.state.updateData.burdenRateId &&
          !breakCondition && ele.endDate !== null &&
          ele.endDate === '0001-01-01T00:00:00'
          // && this.isDateInSamePayCycle(moment(ele.startDate).format("YYYY-MM-DD"),this.state.updateData.startDate)

        ) {
          const matchedDepartment = this.isDesignationPresent(ele);
          if (matchedDepartment.length > 0) {
            if (ele.designationId === this.state.updateData.designationId) {
              isNewParamValid = true;
            } else if (moment(ele.startDate).format('YYYY/MM/DD') >= this.state.updateData.startDate ||
              this.isDateInSamePayCycle(moment(ele.startDate).format('YYYY/MM/DD'), this.state.updateData.startDate)
            ) {
              isStartDateSame = true;
            }
            filterBurdenData = ele;
            breakCondition = true;
          }
          // return;
        }
      });
      if (isStartDateSame) {
        newParam = false;
      } else if (isNewParamValid) {
        newParam = true;
      } else if (filterBurdenData !== null && filterBurdenData !== undefined) {
        debugger;
        newParam.parentRecordId = filterBurdenData.burdenRateId;

        this.setState({
          updateData: newParam
        });
      }
    }

    return newParam;
  }

  /**
   * returns start date
   * @returns
   */
  getStartDate () {
    let stDate = (this.state.burdenMasterData || []).filter(
      (x) => x.burdenRateId === this.state.updateData.burdenRateId
    );
    if (stDate.length > 0 && stDate !== undefined && stDate !== null) {
      stDate = stDate[0].startDate;
      return stDate;
    } else {
      return null;
    }
  }

  IsDeptExistsWithDifferentBurdenRate (ele) {
    const existingDepartmentId = ele.designationId.split('|');
    const newDepartmentId = this.state.updateData.designationId.split('|');
    let matchedDepartment = null;
    if (ele.burdenRateId !== this.state.updateData.burdenRateId) {
      matchedDepartment = existingDepartmentId.filter((m) =>
        newDepartmentId.some((n) => m === n)
      );
    }

    return matchedDepartment;
  }

  IsDeptNameExistsWithDifferentBurdenRate (ele) {
    const existingDepartment = ele.designation.split('|');
    const newDepartment = this.state.updateData.designation.split('|');
    let matchedDepartment = null;
    if (ele.burdenRateId !== this.state.updateData.burdenRateId) {
      matchedDepartment = existingDepartment.filter((m) =>
        newDepartment.some((n) => m?.toLowerCase()?.trim() === n?.toLowerCase()?.trim())
      );
    }

    return matchedDepartment;
  }

  checkAtleastOnePresent = () => {
    let message = '';
    let titles = '';
    let burdenRateName = '';
    const activeRecord = this.state.burdenMasterData.filter(x =>
      (x.endDate === null ||
          x.endDate === '0001-01-01T00:00:00' || moment(x.endDate).format(DateFormat) >= moment(this.state.updateData.startDate).format(DateFormat))
    );
    if (activeRecord?.length > 0) {
      activeRecord.forEach((ele) => {
        const matchedDepartment = this.IsDeptExistsWithDifferentBurdenRate(ele);
        if (matchedDepartment?.length > 0) {
          titles += titles !== undefined && titles !== null && titles !== '' ? ', ' + this.IsDeptNameExistsWithDifferentBurdenRate(ele).join(', ') : this.IsDeptNameExistsWithDifferentBurdenRate(ele).join(', ');
          burdenRateName += burdenRateName !== undefined && burdenRateName !== null && burdenRateName !== '' ? ', ' + ele.burdenRate : ele.burdenRate;
        }
      });
      if (titles !== undefined && titles !== null && titles !== '' && burdenRateName !== undefined && burdenRateName !== null) {
        message = 'The designation(s) ' + titles + ' is present in ' + burdenRateName + ' group(s). Please edit or remove designation(s) from that group.';
      }
    }
    return message;
  }

  /**
   * add or update record
   */
  saveUpdatedRecord = () => {
    if (!this.isValidForm()) { return false; } else {
      let newParam = [];
      let isValid = false;
      const currentPaycycleStartDate = getCurrentPayCycleStartDate();
      const currentMonthStartDate = moment().startOf('month').format('YYYY/MM/DD');
      const currentMonthMidDate = moment(currentMonthStartDate, 'YYYY/MM/DD').add(14, 'days');
      newParam = this.isDeptExistInBurdenGroup();

      if (newParam === null) {
        ShowToast('Record with same designation(s) already present for same date.', toastType.ERROR, 5000, 5000);
        return false;
      } else if (newParam === false) {
        // this.setState({
        //   isStartDateSame : false
        // }, ()=>{ this.forceUpdate();})
        ShowToast(
          'Please select either different date or update same record . It seems record with either same date or greater is already present .',
          toastType.ERROR,
          5000,
          5000
        );
      } else if (newParam === true) {
        ShowToast(
          'Record already present .Please modify existing record.',
          toastType.ERROR,
          5000,
          5000
        );
      } else if (this.isBurdenRateValid(newParam.burdenRatePercent)) {
        //  || newParam.burdenRate === '' ||
        //   newParam.burdenRate === null || newParam.designationId === '' || newParam.startDate === null) {
        ShowToast('Please enter valid value in Burden Rate Percent. It should be greater than 0 and less than equal to 100.', toastType.ERROR, 5000, 5000);
        return false;
      } else if (this.checkAtleastOnePresent() !== '') {
        ShowToast(
          this.checkAtleastOnePresent(),
          toastType.ERROR,
          5000,
          5000
        );
      } else {
        if (!this.state.isInAddMode) {
          // if (moment(this.state.updateData.startDate).format('YYYY/MM/DD') < moment().format('YYYY/MM/DD')) {
          if (moment(this.state.updateData.startDate).format('YYYY/MM/DD') < currentPaycycleStartDate.format('YYYY/MM/DD')) {
            ShowToast('Application start date should be current paycycle or future date.', toastType.ERROR, 5000, 5000);
            return false;
          }
        }
        const stDate = this.getStartDate();

        if (this.state.isInAddMode) {
          newParam.flag = false;
        } else {
          newParam = this.state.updateData;
          if (this.isDateInCurrentPayCycle(stDate) || this.isDateInNextPayCycle(stDate)) { isValid = true; }
          if (isValid) {
            newParam.flag = false;
          } else {
            newParam.flag = true;
          }
        }

        // check if start date is valid for update record
        if (
          stDate !== null &&
          stDate !== undefined &&
          stDate !== null &&
          (moment(stDate).format('YYYY/MM/DD') === moment(newParam.startDate).format('YYYY/MM/DD') ||
            // moment(newParam.startDate).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')
            moment(newParam.startDate).format('YYYY/MM/DD') >= currentPaycycleStartDate.format('YYYY/MM/DD')
          )
        ) {
          if (
            newParam.parentRecordId !== undefined &&
            newParam.parentRecordId !== 0
          ) {
            this.setState({
              confirmMessage: 'Record with similar designation already present.Do you want to split?',
              showWarningMessage: true,
              updateData: newParam,
              reloadTable: !this.state.reloadTable
            });
            this.forceUpdate();
          } else this.saveRecord(newParam);
        }
        // check if start date is valid for new record
        else if (
          stDate === null &&
          // moment(newParam.startDate).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')
          moment(newParam.startDate).format('YYYY/MM/DD') >= currentPaycycleStartDate.format('YYYY/MM/DD')
        ) {
          if (
            newParam.parentRecordId !== undefined &&
            newParam.parentRecordId !== 0
          ) {
            this.setState({
              confirmMessage: 'Record with similar designation already present.Do you want to split?',
              showWarningMessage: true,
              updateData: newParam
            });
            this.forceUpdate();
          } else this.saveRecord(newParam);
        } else {
          ShowToast('Applicable From date should be current paycycle or future date', toastType.ERROR, 5000, 5000);
          return false;
        }
      }
    }
  };

  /**
   * save record into database table
   * @param {*} newParam
   * @returns
   */
  saveRecord (newParam) {
    if (newParam !== null && newParam.startDate !== null && typeof newParam.startDate === 'object') {
      newParam.startDate = newParam.startDate.format('YYYY/MM/DD');
    }
    if ((this.state.validationMessage || []).length > 0) { return false; }
    apiPost({
      url: API_URL.Users.UpdateBurdenRateDepartment,
      postBody: newParam
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? 'Record added successfully.'
            : 'Record updated successfully.',
          toastType.SUCCESS,
          5000,
          500
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          showWarningMessage: false,
          isInAddMode: false
        });
        this.getRequiredData();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  }

  /**
   * check if given date is in current pay cycle
   * @param {*} date
   * @returns bool
   */
  isDateInCurrentPayCycle (date) {
    let isValid = false;
    const currentMonthStartDate = moment()
      .startOf('month')
      .format('YYYY/MM/DD');
    const currentMonthMidDate = moment(currentMonthStartDate, 'YYYY/MM/DD').add(
      14,
      'days'
    );
    const currentMonthLastDate = moment().endOf('month').format('YYYY/MM/DD');
    if (
      (moment(date).format('YYYY/MM/DD') >= moment(currentMonthStartDate).format('YYYY/MM/DD') &&
        moment(date).format('YYYY/MM/DD') <= currentMonthMidDate.format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') >= moment(currentMonthStartDate).format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') <= currentMonthMidDate.format('YYYY/MM/DD')
      ) ||
      (moment(date).format('YYYY/MM/DD') >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') &&
        moment(date).format('YYYY/MM/DD') <= moment(currentMonthLastDate).format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') >= currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD') &&
        moment().format('YYYY/MM/DD') <= moment(currentMonthLastDate).format('YYYY/MM/DD')
      )
    ) { isValid = true; } else isValid = false;
    return isValid;
  }

  /**
   * add new record in grid table
   * @returns
   */
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const burdenRateColumns = _.cloneDeep(burdenRateColumnsList);
    const currentPaycycleStartDate = getCurrentPayCycleStartDate();
    const rowNew = {
      parentRecordId: 0,
      splitDesignation: false,
      burdenRateId: 0,
      burdenRate: '',
      burdenRatePercent: 0,
      startDate: currentPaycycleStartDate, // moment().format('YYYY/MM/DD'),
      endDate: undefined,
      designationId: null,
      designation: undefined,
      flag: false,
      createdBy: '',
      createdDate: moment().format('YYYY/MM/DD'),
      statusId: 0,
      modifiedBy: '',
      modifiedDate: moment().format('YYYY/MM/DD')
    };

    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: 'burdenRateId', value: 0 },
      updateData: rowNew,
      reloadTable: !this.state.reloadTable,
      burdenRateColumns
    });
  };

  /**
   * cancel row open for add mode
   */
  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !this.state.relaodTable
    });
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !this.state.relaodTable
    });
  };

  /**
   * check if given date is in next pay cycle
   * @param {*} date
   * @returns bool
   */
  isDateInNextPayCycle (date) {
    let isNext = false;
    isNext = this.isDateInCurrentPayCycle(date);
    if (isNext === false && moment(date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD')) { isNext = true; } else { isNext = false; }
    return isNext;
  }

  EditRecord = (cellInfo) => {
    const burdenRateColumns = _.cloneDeep(burdenRateColumnsList);
    burdenRateColumns.forEach(x => {
      if (x.key === 'burdenRate') {
        x.disabled = true;
      }
    });
    this.setState({
      selectedEditRowId: {
        key: 'burdenRateId',
        value: cellInfo.burdenRateId
      },
      isInAddMode: false,
      updateData: { ...cellInfo },
      reloadTable: !this.state.relaodTable,
      burdenRateColumns
    });
  }

  isArrayEquals = (a, b) => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; ++i) {
      if (b.find(x => parseInt(x) === parseInt(b[i])) === undefined) return false;
    }
    return true;
  }

  isEditIconVisible = (cellInfo) => {
    const { burdenMasterData } = this.state;
    if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_BURDEN_RATE, SECTIONS.ADD_EDIT)) {
      const burdenData = burdenMasterData.filter(x => x.burdenRate === cellInfo.burdenRate && this.isArrayEquals(x.designationId.split('|'), cellInfo.designationId.split('|')));
      console.log(burdenData);
      if (cellInfo !== undefined &&
        (cellInfo.endDate === null ||
          cellInfo.endDate === '0001-01-01T00:00:00' || moment(cellInfo.endDate).format(DateFormat) > moment().format(DateFormat))) {
        return true;
      }
      if ((burdenData || []).length > 1) {
        const latest = burdenData.reduce(function (r, a) {
          return moment(r.startDate).format(DateFormat) > moment(a.startDate).format(DateFormat) ? r : a;
        });
        if (latest.burdenRateId !== cellInfo.burdenRateId) {
          return false;
        }
      }
    }
    return false;
  }
  // getStartDate(id)
  // {
  //  var startDate= this.state.burdenMasterData.filter(x=>x.burdenRateId==id).startDate;
  //  console.log(startdate);
  //  return moment(startDate).format('YYYY-DD-MM');
  // }

  /**
   * render action column on grid table
   * @param {*} cellInfo
   * @param {*} isInAddMode
   * @returns
   */
  renderActionColumn = (cellInfo, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.burdenRateId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.saveUpdatedRecord}
                >
                  <SaveIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={isInAddMode ? this.cancelAddMode : this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>

            </>
            )
          : <> {
            this.isEditIconVisible(cellInfo) && (
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )
          }
            { cellInfo !== undefined && cellInfo.startDate !== undefined && cellInfo.startDate !== null && moment(cellInfo.startDate).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')
              ? (
                <Tooltip title="Delete">
                  <IconButton aria-label={'refreshData'} size="small" onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                  >
                    <DeleteIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>
                )
              : null}
          </>
        }

      </>
    );
  };

  validateField = (fieldName, message) => {
    const validationMessage = this.state.validationMessage;
    if (!validationMessage.find(x => x.key === fieldName)) {
      validationMessage.push({ key: fieldName, message: message });
    }
    this.setState({ validationMessage: validationMessage });
  };

  /**
   * handle on change
   * @param {*} value
   * @param {*} fieldName
   */
  handleTableEditChange = (value, fieldName) => {
    const designationData = this.state.designationMasterData;
    const param = this.state.updateData;
    const { burdenRateColumns } = this.state;
    const validationMessage = this.state.validationMessage;
    if (fieldName === 'designation') {
      const valueOfDesignation = [];
      value.forEach((val) => {
        designationData.find((x) => x.designation === val) &&
          valueOfDesignation.push(
            designationData.find((x) => x.designation === val).designationID
          );
      });
      param.designationId = valueOfDesignation.join('|');
      param[fieldName] = value.join('|');
    } else if (fieldName === 'burdenRate') {
      param[fieldName] = value || [];
      // this.validateField(fieldName, 'BurdenRate is required.');
    } else if (fieldName === 'burdenRatePercent') {
      param[fieldName] = value || [];
      this.isBurdenRateValid(fieldName, value);
      // this.validateField(fieldName, 'BurdenRatePercent is required.');
    } else if (fieldName === 'startDate') {
      param[fieldName] = value || [];
    } else if (fieldName === 'endDate') {
      param[fieldName] = value || [];
    } else {
      param[fieldName] = value;
    }

    param.cloudOrgId = param.cloudOrgId === undefined ? 1 : param.cloudOrgId;
    param.userEmail =
      param.userEmail === undefined
        ? (((store.getState() || {}).auth || {}).account || {}).userName
        : param.userEmail;

    isGridFormValid(value, burdenRateColumns.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) });

    this.forceUpdate();
  };

  /**
     * is Form Valid
     */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, burdenRateColumns } = this.state;
    burdenRateColumns.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ burdenRateColumns }, this.forceUpdate());
    return IsValid;
  };

  /**
   * handle dialog box click event
   * @param {*} e
   */
  onClickHandel (e) {
    if (this.state.isDelete) {
      this.onDeleteHandel(e);
    } else {
      this.setState({
        showWarningMessage: false
      });
      let newParam = [];
      newParam = this.state.updateData;
      newParam.splitDesignation = e;
      if (e) this.saveRecord(newParam);
    }
  }

  render () {
    const { designationMasterData, burdenRateColumns } = this.state;

    const EditSource = [];
    EditSource.push({
      key: 'designationMasterData',
      data: designationMasterData
    });
    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}

        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Burden Rate Configuration
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_BURDEN_RATE, SECTIONS.ADD_EDIT) && <TableRow>
              <TableCell>
                {/* <span style={{ color: 'red' }}> */}
                <b>
                  Please select continuous dates while setting up Burden Rates as it affects the Reimbursement Calculations.
                </b>
                {/* </span> */}
              </TableCell>
            </TableRow>}
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={UpdateColumnWithConfiguration(
                    burdenRateColumns,
                    this.state.configuration,
                    []
                  )}
                  data={this.state.burdenMasterData}
                  isInline={true}
                  config={burdenRateColumns}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: 'Add New Burden Rate',
                    visible: IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_BURDEN_RATE, SECTIONS.ADD_EDIT)
                  }}
                  reload={this.state.reloadTable}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
